<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            Créez votre compte
          </h4>
          <form @submit.prevent="handleSubmit">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10"
                >Nom Complet (*)</label
              >
              <input
                type="text"
                v-model="name"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse e-mail (*)
              </label>
              <input
                type="email"
                v-model="email"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>

             <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Numéro de téléphone (*)
              </label>
              <input
                type="text"
                pattern="[0-9]*"
                inputmode="numeric"
                v-model="phone"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                CIN (*)
              </label>
              <input
                type="text"
                v-model="cin"
                class="form-control shadow-none rounded-0 text-black"
              />
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Ville
              </label>
              <v-select 
                    class="custom-select-height"
                    :options="citiesList"
                    label="name"
                    v-model="city"
                    placeholder="Ville *"
                  />
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Message 
              </label>
             <textarea
                rows="3"
                v-model="message"
                class="form-control shadow-none rounded-0 text-black"
              ></textarea>
            </div>
            
            <!-- <div
              class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20"
            >
              <input
          class="form-check-input shadow-none"
          type="checkbox"
          id="remember-me"
              />
              <label class="form-check-label" for="remember-me">
          J'accepte tous les
          <a href="#" class="text-decoration-none">termes et conditions</a>
              </label>
            </div> -->
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              type="submit"
            >
              S'inscrire
            </button>
            <span
              class="d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
            >
              Vous avez déjà un compte ?
            </span>
            <router-link
              to="/login"
              class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            >
              Se connecter
            </router-link>
            <!-- <span
              class="d-block or text-muted text-center mt-15 mb-15 mt-md-20 mb-md-20 fs-md-15 fs-lg-16 position-relative z-1 lh-1"
            >
              <span class="d-inline-block bg-white">Ou</span>
            </span>
            <ul class="socials ps-0 mb-0 list-unstyled text-center">
              <li class="d-inline-block">
          <button
            type="button"
            class="d-block rounded-circle text-center position-relative facebook border-0 p-0"
          >
            <i class="ph-fill ph-facebook-logo"></i>
          </button>
              </li>
              <li class="d-inline-block">
          <button
            type="button"
            class="d-block rounded-circle text-center position-relative google border-0 p-0"
          >
            <i class="ph-bold ph-google-logo"></i>
          </button>
              </li>
              <li class="d-inline-block">
          <button
            type="button"
            class="d-block rounded-circle text-center position-relative twitter border-0 p-0"
          >
            <i class="ph-fill ph-twitter-logo"></i>
          </button>
              </li>
              <li class="d-inline-block">
          <button
            type="button"
            class="d-block rounded-circle text-center position-relative linkedin border-0 p-0"
          >
            <i class="ph-fill ph-linkedin-logo"></i>
          </button>
              </li>
            </ul> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
    import { useAppToast } from '@/composables/useAppToast';
import api from '@/utils/axios';
import { onMounted } from 'vue';
import { ref } from 'vue';

export default {
  name: "RegisterContent",
  setup(){
    const { showToast } = useAppToast();


    const name = ref('');
    const phone = ref('');
    const email = ref('');
    const cin = ref('');
    const city = ref<any>({});
    const message = ref('');
    const citiesList = ref([]);

     onMounted(async () => {
      try {
        const response = await api.get('api/auth/listCities');
        citiesList.value = response.data;
      } catch (error) {
        console.error('Error fetching cities:', error);
      }

     });


    async function handleSubmit() {
      // Simple validation example, you can expand as needed
      if (!name.value || !email.value || !phone.value || !cin.value || !city.value.id) {
        showToast('Veuillez remplir tous les champs obligatoires.');
        return;
      }
      try {
        let data = new FormData();
        data.append('name', name.value);
        data.append('phone', phone.value);
        data.append('email', email.value);
        data.append('cin', cin.value);
        data.append('city_id', city.value.id);
        data.append('city_name', city.value.name);
        data.append('message', message.value);

        const res = await api.post(`/api/auth/new_liv_request`, data);
        if (res.data.message === 'success') {
          showToast('Votre demande est bien enregistrée.', "success");
          name.value = '';
          phone.value = '';
          email.value = '';
          cin.value = '';
          city.value = {};
          message.value = '';
          
        } else if (res.data.message === 'exist mail') {
          showToast("Adresse électronique existe déjà.", "error");
        } else if (res.data.message === 'exist cin') {
          showToast("CIN existe déjà.", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue. Veuillez réessayer.", "error");
      }
    }

    return {
      name,
      phone,
      email,
      cin,
      city,
      message,
      citiesList,
      handleSubmit
    };
  }
};
</script>